import React from 'react';
import styled, { css } from 'styled-components';
import { fonts, palette } from 'theme';
import { borderRadius } from 'polished';

import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';

const CheckoutFormControlLabel = styled(({ withCollapse, ...other }) => (
  <FormControlLabel
    control={<Radio color="primary" />}
    classes={{ label: 'label' }}
    {...other}
  />
))`
  margin-left: 0;
  margin-right: -14px;
  max-width: 100%;
  ${borderRadius('top', '5px')}
  ${props =>
    !props.withCollapse &&
    css`
      ${borderRadius('bottom', '5px')}
    `}
  
  border: 1px solid transparent;
  border-bottom-width: ${props => (props.withCollapse ? 0 : '1px')};

  ${props =>
    props.checked &&
    css`
      background: ${palette.action.hover};
      border-color: ${palette.primary.main};
    `}

  & .label {
    font-weight: normal;
    font-family: ${fonts.headingFamily};
    color: ${palette.text.primary};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const CheckoutCollapse = styled(Collapse)`
  padding-left: 48px;
  padding-right: 24px;

  ${props =>
    props.in &&
    css`
      ${borderRadius('bottom', '5px')}
      border: 1px solid ${palette.primary.main};
      border-top: 0;
      background: ${palette.action.hover};
    `}
`;

export { CheckoutFormControlLabel, CheckoutCollapse };
